import { FunctionComponent } from "react";

export const UserIcon: FunctionComponent = () => {
	return <i className="fa fa-user icon" aria-hidden="true"></i>;
}

export const EmailIcon: FunctionComponent = () => {
	return <i className="fa fa-envelope icon" aria-hidden="true"></i>;
}

export const EmailNormalIcon: FunctionComponent = () => {
	return <i className="fa fa-envelope" aria-hidden="true"></i>;
}

export const PasswordIcon: FunctionComponent = () => {
	return <i className="fa fa-lock icon iconPass" aria-hidden="true"></i>;
}

export const KeyIcon: FunctionComponent = () => {
	return <i className="fa fa-key icon" aria-hidden="true"></i>;
}

export const LogoutIcon: FunctionComponent = () => {
	return <i className="fa fa-sign-out" aria-hidden="true"></i>;
}

export const LoginIcon: FunctionComponent = () => {
	return <i className="fa fa-sign-in" aria-hidden="true"></i>;
}

export const TimesIcon: FunctionComponent = () => {
	return <i className="fa fa-times" aria-hidden="true"></i>;
}

export const RegisterIcon: FunctionComponent = () => {
	return <i className="fa fa-user-plus" aria-hidden="true"></i>;
}

export const PlusIcon: FunctionComponent = () => {
	return <i className="fa fa-plus" aria-hidden="true"></i>;
}

export const MinusIcon: FunctionComponent = () => {
	return <i className="fa fa-minus" aria-hidden="true"></i>;
}

export const EditIcon: FunctionComponent = () => {
	return <i className="fa fa-pencil" aria-hidden="true"></i>;
}

export const LargeSpinnerIcon: FunctionComponent = () => {
	return <i className="fa fa-spinner fa-spin fa-2x" aria-hidden="true"></i>;
}

export const SpinnerIcon: FunctionComponent = () => {
	return <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>;
}

export const ErrorIcon: FunctionComponent = () => {
	return <i className="fa fa-exclamation-circle" aria-hidden="true"></i>;
}

export const SettingsIcon: FunctionComponent = () => {
	return <i className="fa fa-cog" aria-hidden="true"></i>;
}

export const SearchIcon: FunctionComponent = () => {
	return <i className="fa fa-search" aria-hidden="true"></i>;
}

export const CameraIcon: FunctionComponent = () => {
	return <i className="fa fa-camera" aria-hidden="true"></i>;
}

export const FullScreenIcon: FunctionComponent = () => {
	return <i className="fa fa-arrows-alt" aria-hidden="true"></i>;
}

export const FastForwardIcon: FunctionComponent = () => {
	return <i className="fa fa-fast-forward" aria-hidden="true"></i>;
}

export const CheckIcon: FunctionComponent = () => {
	return <i className="fa fa-check" aria-hidden="true"></i>;
}

export const FlagIcon: FunctionComponent = () => {
	return <i className="fa fa-flag" aria-hidden="true"></i>;
}

export const CaretDownIcon: FunctionComponent = () => {
	return <i className="fa fa-caret-down" aria-hidden="true"></i>;
}

export const WarningIcon: FunctionComponent = () => {
	return <i className="fa fa-warning" aria-hidden="true"></i>;
}

export const FilterIcon: FunctionComponent = () => {
	return <i className="fa fa-filter" aria-hidden="true"></i>;
}

export const VerboseIcon: FunctionComponent = () => {
	return <i className="fa fa-comment-o" aria-hidden="true"></i>;
}

export const PlayIcon: FunctionComponent = () => {
	return <i className="fa fa-play" aria-hidden="true"></i>;
}

export const RePlayIcon: FunctionComponent = () => {
	return <i className="fa fa-repeat" aria-hidden="true"></i>;
}

export const PauseIcon: FunctionComponent = () => {
	return <i className="fa fa-pause" aria-hidden="true"></i>;
}

export const NextIcon: FunctionComponent = () => {
	return <i className="fa fa-step-forward" aria-hidden="true"></i>;
}

export const PrevIcon: FunctionComponent = () => {
	return <i className="fa fa-step-backward" aria-hidden="true"></i>;
}

export const VolumeUpIcon: FunctionComponent = () => {
	return <i className="fa fa-volume-up" aria-hidden="true"></i>;
}

export const VolumeDownIcon: FunctionComponent = () => {
	return <i className="fa fa-volume-down" aria-hidden="true"></i>;
}

export const VolumeOffIcon: FunctionComponent = () => {
	return <i className="fa fa-volume-off" aria-hidden="true"></i>;
}

export const VolumeMutedIcon: FunctionComponent = () => {
	return <span className="fa-stack">
		<i className="fa fa-volume-off fa-stack-1x" aria-hidden="true"></i>
		<i className="fa fa-ban fa-stack-1x"></i>
	</span>;
}

export const HeartOutlineIcon: FunctionComponent = () => {
	return <i className="fa fa-heart-o" aria-hidden="true"></i>;
}

export const HeartFullIcon: FunctionComponent = () => {
	return <i className="fa fa-heart" aria-hidden="true"></i>;
}

export const LinkIcon: FunctionComponent = () => {
	return <i className="fa fa-link" aria-hidden="true"></i>;
}

export const CrossIcon: FunctionComponent = () => {
	return <i className="fa fa-times icon" aria-hidden="true"></i>;
}

export const TrashIcon: FunctionComponent = () => {
	return <i className="fa fa-trash" aria-hidden="true"></i>;
}

export const DownloadIcon: FunctionComponent = () => {
	return <i className="fa fa-download" aria-hidden="true"></i>;
}

export const TaskIcon: FunctionComponent = () => {
	return <i className="fa fa-tasks" aria-hidden="true"></i>;
}

export const FilmIcon: FunctionComponent = () => {
	return <i className="fa fa-film" aria-hidden="true"></i>;
}

export const SaveIcon: FunctionComponent = () => {
	return <i className="fa fa-save" aria-hidden="true"></i>;
}

export const ClockIcon: FunctionComponent = () => {
	return <i className="fa fa-clock-o" aria-hidden="true"></i>;
}

export const BanIcon: FunctionComponent = () => {
	return <i className="fa fa-ban" aria-hidden="true"></i>;
}

export const CommentingIcon: FunctionComponent = () => {
	return <i className="fa fa-commenting-o" aria-hidden="true"></i>;
}

export const LanguageIcon: FunctionComponent = () => {
	return <i className="fa fa-language" aria-hidden="true"></i>;
}

export const StarIcon: FunctionComponent = () => {
	return <i className="fa fa-star" aria-hidden="true"></i>;
}

export const PodcastIcon: FunctionComponent = () => {
	return <i className="fa fa-podcast" aria-hidden="true"></i>;
}